import { Typography, Table, TableHead, TableCell, TableRow, TableBody } from '@material-ui/core';
import Moment from 'react-moment';
import { IServiceOrder } from '../TicketPrint';

interface IProps {
    serviceOrders: IServiceOrder[]
}

let ServiceOrders = ({ serviceOrders }: IProps) => {
    return (
        <>
            <Typography style={{ marginTop: 16 }} variant="h5">Service orders</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>M3 Order Number</TableCell>
                        <TableCell>Assignment Number</TableCell>
                        <TableCell>Created By</TableCell>
                        <TableCell>Created On</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {serviceOrders.map(order =>
                        <TableRow key={order.id}>
                            <TableCell>{order.m3OrderNumber}</TableCell>
                            <TableCell>{order.assignmentNumber}</TableCell>
                            <TableCell>{order.createdBy}</TableCell>
                            <TableCell>
                                <Moment date={order.createdOn} format="ll" />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </>
    )
}

export default ServiceOrders;